/* How finished a profile is, and what to fill in next.

   This is the honest replacement for the AI writing assistant: most of what
   made that idea valuable was simply *asking for one thing at a time* instead
   of presenting eleven empty boxes at once.

   Order matters. `says_yes_to` is first because it is the field the matcher
   leans on hardest, and a profile with nothing else but that one filled in is
   more useful than the reverse. */

const FIELDS = [
  {
    key: 'says_yes_to',
    from: 'intent',
    label: 'A conversation you would say yes to right now',
    hint: 'Be specific. "Anyone in DeFi" matches nobody useful; "someone who has shipped a fiat off-ramp in SEA" matches the right person.',
    weight: 3,
  },
  { key: 'headline', from: 'profile', label: 'Your headline', hint: 'One line: what you do and who for.', weight: 2 },
  { key: 'role_tags', from: 'profile', label: 'What best describes you', hint: 'Founder, advisor, investor… it decides who you are introduced to.', weight: 1, isList: true },
  { key: 'categories', from: 'profile', label: 'Your categories', hint: 'These seed what the feed shows you before it has learned anything.', weight: 2, isList: true },
  { key: 'building', from: 'profile', label: 'What you are building', hint: 'What is actually taking your time this month.', weight: 2 },
  { key: 'seeking', from: 'intent', label: 'What you are looking for', hint: 'People, work, capital, collaborators — whatever is true.', weight: 1 },
  { key: 'offering', from: 'intent', label: 'What you can offer', hint: 'What you are worth asking about.', weight: 1 },
  { key: 'working_through', from: 'profile', label: 'What you are working through', hint: 'A problem you have not solved yet. This is what makes an introduction land.', weight: 1 },
  { key: 'not_looking_for', from: 'intent', label: 'What you are not looking for', hint: 'Saves everyone time. Perfectly fine to leave blank.', weight: 1 },
];

function filled(value, isList) {
  if (isList) return Array.isArray(value) && value.length > 0;
  return typeof value === 'string' && value.trim().length > 0;
}

export function completeness(profile, intent) {
  if (!profile) return { percent: 0, next: null, missing: [], done: 0, total: FIELDS.length };

  const source = { profile: profile || {}, intent: intent || {} };
  let earned = 0;
  let possible = 0;
  let done = 0;
  let next = null;
  const missing = [];

  for (const field of FIELDS) {
    possible += field.weight;
    if (filled(source[field.from][field.key], field.isList)) {
      earned += field.weight;
      done += 1;
    } else {
      missing.push(field);
      if (next === null) next = field;
    }
  }

  return {
    percent: Math.round((earned / possible) * 100),
    next,
    missing,
    done,
    total: FIELDS.length,
  };
}
